import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ApiGo from '../../../actions/ApiGo'
import { useDispatch, useSelector } from 'react-redux'
import { ADD_RESIDENTS_ARRAY } from '../../../stores/reducer_residentsArray'

const UserInfo =(props)=>{
    let _info = props.data
    const {t, i18n} = useTranslation()
    const store_res_array = useSelector(state => state.store_residents.orign_residents_array)

    function handleRole(_role){
        switch (_role) {
            case "superdoctor": return t("GLOBAL.SUPERDOCTOR");
            case "doctor": return t("GLOBAL.DOCTOR");
            case "admin": return t("GLOBAL.ADMIN");
            default:
                break;
        }
    }
    return(
    <div className="pos-f z-1 wid-full hig-full top-0 left-0 fx-ccc bg-black" onClick={props.hide}>
        <div className="layout-history fx-d-c pad-30 l r" onClick={e=>e.stopPropagation()}>
            <div className="h-100 fx-d-c w-100 font-ml pad-31">
                <div className='w-90 fx-d-r fx-fsc h-10 '>
                    <div className='font-xl'>
                        {(i18n.language==="en")? <>{_info.first_name} {_info.last_name}</>
                        :<>{_info.last_name}{_info.first_name}</>
                        }      
                    </div>
                    <div className='font-l margl-xs border bgC-alert-E pad-5 l r fx-ccc'>{handleRole(_info.role)}</div>
                </div>
                <div className='h-10'>{_info.email}</div>
                <div className='font-l h-5'>{t("ADMIN.CONNECTION_HIS_PAGE.ASSIGNED_RES")}</div>
                <div className='border br-10 w-90 h-60 pad-5 l b r t'>{(_info.resident_assign!==null)? _info.resident_assign.split(",").map(res=>{
                    let _resident = store_res_array.filter(e => e.id === parseInt(res))[0] || {}
                    return <div className='w-40 margr-xs fx-d-r fx-fsc'>
                        <div className='w-50'>{_resident.first_name}</div>
                        <div>{_resident.last_name}</div>
                    </div>
                }): null }</div>
            </div>
        </div>
    </div>
    );	

}
export default UserInfo;